import { computed } from 'mobx'
import { Model } from 'libx'
import moment from 'moment'
import { omitUndefined } from 'utils/objectUtil'
import Amendment from './Amendment'

export default class JobEvent extends Model {
  @computed get job () {
    return this.rootStore.projectStore.projects.get(this.jobId)
  }

  parse (json) {
    const user = (value) =>
      value
        ? this.rootStore.userStore.users.set(value)
        : null

    const quote = (value) => ({
      adminFeeAmount: value.admin_fee_amount,
      couponAmount: value.coupon_amount,
      primaryAmount: value.primary_amount,
      providerCutAmount: value.provider_cut_amount,
      grossAmount: value.gross_amount,
      amendedAmount: value.amended_amount,
      total: value.total
    })

    const previousProvider = user(json.previous_provider)
    const provider = user(json.provider)
    const newProvider = user(json.new_provider)
    const triggeredBy = user(json.triggered_by)

    // Refresh all these users.
    this.rootStore.userStore.refreshProfiles(
      [previousProvider, provider, newProvider, triggeredBy].filter(x => x).map(x => x.id)
    )

    if (json.snapshot && json.snapshot.date_modified) {
      // Update the in-memory job if we have one, but only if
      // the snapshot is newer than what we have.
      const job = this.rootStore.projectStore.projects.get(json.snapshot.id)
      if (!job || (job.dateUpdated && moment(json.snapshot.date_modified).isAfter(job.dateUpdated))) {
        // Snapshot is newer than what we have; set it.
        this.rootStore.projectStore.projects.set(json.snapshot)
      }
    }

    return omitUndefined({
      id: json.id,
      dateCreated: moment(json.date_created),
      jobId: json.job_id,
      amendment: json.amendment
        ? new Amendment(
          json.amendment,
          { parse: true, rootStore: this.rootStore, job: this.rootStore.projectStore.projects.set({ id: json.job_id }) }
        )
        : null,
      reason: json.reason,
      description: json.description,
      dateTransmitted: json.date_transmitted ? moment(json.date_transmitted) : null,
      dateAccepted: json.date_accepted ? moment(json.date_accepted) : null,
      dateReopened: json.date_reopened ? moment(json.date_reopened) : null,
      dateClosed: json.date_closed ? moment(json.date_closed) : null,
      previousProvider,
      provider,
      newProvider,
      triggeredBy,
      eventVisibility: json.event_visibility,
      eventType: json.event_type,
      rebound: json.rebound,
      previousQuote: quote(json.previous_quote),
      newQuote: quote(json.new_quote)
    })
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/JobEvent.js